import web_editor from './web_editor'
import portal from './portal'

export default {
  ...web_editor,
  ...portal
}
